import "./admin-root.component.scss";

export default {
  template: require('./admin-root.component.html'),
  controller: function ($auth) {
    'ngInject';

    const self = this;

    self.auth = $auth;
  }
};
